/** Idiomas da interface: fonte única para o front (i18n, store, Vuetify) e para o backend (link no idioma de quem gerou). */

export const DEFAULT_LOCALE = 'pt-BR';

export const SUPPORTED_LOCALES = ['pt-BR', 'es', 'en', 'pt-PT'];

/** Header em que o front manda o idioma da tela em todo pedido. */
export const LOCALE_HEADER = 'X-App-Locale';

/** Parâmetro do link externo (?lang=es): a página abre no idioma de quem gerou o link. */
export const LOCALE_QUERY_PARAM = 'lang';

/** Só idioma da lista vale: header e link vêm de fora e podem ter sido editados à mão. */
export function isSupportedLocale(value) {
  return SUPPORTED_LOCALES.includes(value);
}
